export default __webpack_public_path__ + "static/media/t_03_0011.a9de2aed.png";